module.exports = "/_next/static/images/05c4953d86aa4ab7ccd48ee8574a3e20-website-thumb-large.jpg.webp";